exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n/* This is to override a margin caused by bootstrap */\n.non-gfm-markdown-block {\np {\n    margin-bottom: 0;\n}\n}\n", ""]);

